import React, { useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { equals, filter, length, prop, propEq } from 'ramda';
import { EyeOutlined, FileSyncOutlined } from '@ant-design/icons';
import { Components } from '@fasstech/flexiget';
import { renderDate } from '../docs/components/helpers/dates';
import { Section } from '../../components';
import useCompare from '../../hooks/useCompare';
import { sortDateDESC } from '../helpers/sortDate';
import usePagination from '../../hooks/usePagination';
import ComparisonDetails from './ComparisonDetails';
import StatusComparison from './StatusComparison';

const HistoryComparisonsTable = ({ values, userId, setRefetch }) => {
  const frameId = prop('id', values);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [idComparison, setIdComparison] = useState(null);
  const { loadingOnCompareOnSelected: loadingOnCompare, onCompare } = useCompare({
    userId,
    frameIds: [frameId],
    useModal: false,
    setRefetch
  });
  const { comparisons, isReferent, id } = values;
  const listComparisons = sortDateDESC(comparisons);
  const { onChangePagination, pagination } = usePagination({ itemsNumber: length(comparisons), type: 'comparison' });

  return (
    <Section
      className="section-history-comparison shadow-none mt-8"
      title="Historique des comparaisons"
      actions={(
        <Button
          type="primary"
          onClick={() => onCompare('selected', [id])}
          disabled={!isReferent || loadingOnCompare}
          loading={loadingOnCompare}
          icon={<FileSyncOutlined />}
          className="btn-compare-frame"
        >
          Comparer
        </Button>
      )}
    >
      <Table
        size="small"
        dataSource={listComparisons}
        rowKey="id"
        pagination={pagination}
        onChange={(pagination, _filters, _sorter, extra) => onChangePagination(pagination, extra)}
        locale={{ emptyText: 'Aucune donnée' }}
      >
        <Table.Column
          title="Date de comparaison"
          width={200}
          render={({ when, globalStatusResult }) => {
            const date = renderDate(when);
            return (
              <p>{equals('waiting', globalStatusResult) ? 'En cours...' : date}</p>
            );
          }}
        />

        <Table.Column
          title="Statut global"
          dataIndex="globalStatusResult"
          width={90}
          render={(globalStatusResult) => {
            return (
              <StatusComparison status={globalStatusResult} />
            );
          }}
        />

        <Table.Column
          title="Documents identiques"
          width={300}
          render={({ comparisonDetails, globalStatusResult }) => {
            const nbDocPassed = comparisonDetails && length(filter(propEq('passed', 'status'))(comparisonDetails));
            if (equals('waiting', globalStatusResult)) {
              return <p>-</p>;
            } else {
              return (
                <p>{nbDocPassed} / {length(comparisonDetails)}</p>
              );
            }
          }}
        />

        <Table.Column
          title=""
          width={300}
          render={({ globalStatusResult }, _record, index) => {
            if (equals('waiting', globalStatusResult)) return;
            return (
              <div className="flex justify-end gap-2 text-lg">
                <Components.Tooltip
                  title="Voir la comparaison"
                >
                  <EyeOutlined
                    onClick={() => {
                      setIsOpenModal(true);
                      setIdComparison(index);
                    }}
                    className="btn-get-comparison !text-flexi-grey"
                  />
                </Components.Tooltip>
              </div>
            );
          }}
        />
      </Table>
      {isOpenModal && (
        <Modal
          width="90%"
          open={isOpenModal}
          onCancel={() => setIsOpenModal(false)}
          footer={null}
        >
          <ComparisonDetails comparison={listComparisons[idComparison]}/>
        </Modal>
      )}
    </Section>
  );
};

export default HistoryComparisonsTable;
